import PageHero from "@/components/PageHero"
import { useScrollReveal } from "@/hooks/useScrollReveal"
import {Heart, Users, BookOpen, Globe, Handshake} from 'lucide-react'

const projetos = [
  {
    icon: Heart,
    title: "English Work Social",
    text: "Programa que oferece bolsas de estudo integrais para jovens de comunidades em situação de vulnerabilidade social, dando acesso completo ao EW Pass.",
    color: "#B038B2",
  },
  {
    icon: Users,
    title: "Instituto Ponte",
    text: "Parceria com o Instituto Ponte para levar educação em inglês a jovens em processo de ressocialização e inclusão social.",
    color: "#0E8EA0",
  },
  {
    icon: BookOpen,
    title: "EW nas Escolas",
    text: "Programa de apoio a escolas públicas com materiais didáticos, capacitação de professores e acesso à plataforma EW Academy.",
    color: "#F5C542",
  },
  {
    icon: Globe,
    title: "Inglês para Todos",
    text: "Iniciativa que disponibiliza conteúdos gratuitos em redes sociais e YouTube para democratizar o acesso ao aprendizado de inglês.",
    color: "#6CC4C4",
  },
  {
    icon: Handshake,
    title: "Parcerias Comunitárias",
    text: "Colaboração com ONGs, associações e instituições para expandir o alcance do ensino de inglês em regiões carentes.",
    color: "#B038B2",
  },
]

export default function ProjetosSociais() {
  const section1 = useScrollReveal()
  const section2 = useScrollReveal()

  return (
    <>
      <PageHero
        title="Projetos Sociais"
        subtitle="Acreditamos no poder transformador da educação. Conheça as iniciativas sociais da English Work."
      />

      <section className="py-20 bg-white">
        <div
          ref={section1.ref}
          className={`max-w-5xl mx-auto px-5 transition-all duration-700 ${section1.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
        >
          <div className="max-w-3xl mx-auto text-center mb-14">
            <p className="text-gray-600 leading-relaxed">
              A English Work acredita que a educação é a ferramenta mais poderosa para transformar vidas. Por isso, investimos em projetos sociais que levam o aprendizado de inglês a quem mais precisa, derrubando barreiras e criando oportunidades reais.
            </p>
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {projetos.map((item) => (
              <div
                key={item.title}
                className="bg-white rounded-2xl p-7 border border-gray-100 hover:shadow-lg transition-all duration-300 group"
              >
                <div
                  className="w-14 h-14 rounded-xl flex items-center justify-center mb-5 group-hover:scale-110 transition-transform"
                  style={{ backgroundColor: `${item.color}15` }}
                >
                  <item.icon size={26} style={{ color: item.color }} />
                </div>
                <h3 className="text-lg font-bold mb-3 text-gray-900">{item.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Impacto */}
      <section className="py-16" style={{ backgroundColor: "#0E8EA0" }}>
        <div
          ref={section2.ref}
          className={`max-w-5xl mx-auto px-5 text-center transition-all duration-700 ${section2.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
        >
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">Nosso impacto</h2>
          <p className="text-white/80 max-w-2xl mx-auto mb-10">
            Cada aluno que aprende inglês através dos nossos projetos sociais é uma vida transformada, uma porta aberta, uma oportunidade conquistada.
          </p>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {[
              { num: "500+", label: "Bolsas concedidas" },
              { num: "15+", label: "Comunidades atendidas" },
              { num: "10+", label: "Parceiros sociais" },
              { num: "3", label: "Estados alcançados" },
            ].map((item) => (
              <div key={item.label}>
                <p className="text-3xl md:text-4xl font-black text-white">{item.num}</p>
                <p className="text-white/70 text-sm mt-1">{item.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  )
}
